module.exports = __webpack_public_path__ + "img/utahlake.29fec8a9.png";